import React from 'react';
import { Button, Stack } from '@mui/material';
import { ChevronDownIcon } from 'src/icons/ChevronDownIcon';
import { ChevronUpIcon } from 'src/icons/ChevronUpIcon';
import { ts } from 'src/utils/translate';
import { DOUBLE_SPACING } from 'src/theme/style-consts';

type Props = {
    open: boolean;
    onToggle: () => void;
};

export const SettingsDetailsToggle = ({ open, onToggle }: Props) => {
    return (
        <Stack direction="row" justifyContent="center" sx={{ marginTop: DOUBLE_SPACING }}>
            <Button onClick={onToggle} endIcon={open ? <ChevronUpIcon /> : <ChevronDownIcon />}>
                {ts('project_settings_details', 'Details')}
            </Button>
        </Stack>
    );
};
